import gigya from './rbata.gigya';
import personalizeService from '../services/rbata.personalizeService';
import logger from '../utils/rbata.logger';
import tooltip from '../utils/rbata.tooltip';
import contestParticipation from './rbmc.contestQuestions';

const CDC_SUBSCRIBE_IN_STORE_WITH_EMAIL_SCREEN = 'gigya-subscribe-with-physical-store-email-screen';
const CDC_SUBSCRIBE_WITH_EMAIL_SCREEN          = 'gigya-subscribe-with-email-screen-v2';

const gigyaLiteRegistration = {
    newsletterCookieName:             'gigya_nl_subscribed',
    pendingSubscription:              'subscribed_pending',
    CDC_CONTEST_PARTICIPATION_PREFIX: 'gigya-contest',

    /**
     * Wrap gigya date fields in one div for styling purposes.
     */
    wrapFooterNewsletterFields: (mainScreenSetForm) => {
        mainScreenSetForm.find('[class*="birth"]')
                         .wrapAll('<div class="gigya-control--date-wrapper"></div>');
        mainScreenSetForm.find('[class*="input-birth"]:not(:last-child)')
                         .after('<span class="date-delimiter"></span>');
    },

    prefillLanguage: (mainScreenSetForm) => {
        var languageField = mainScreenSetForm.find('[name="data.nl.language"]');
        languageField.find('option[value="' + alphatauri.config.language + '"]') ?
                languageField.val(alphatauri.config.language) :
                languageField.val('en');
    },

    extractAndPrefillUserEmail: (mainScreenSetForm) => {
        var userEmail = new URL(window.location.href).searchParams.get('email');
        if (userEmail) {
            mainScreenSetForm.find('[name="profile.email"]').val(userEmail);
        }
    },

    liteRegisterAfterLoad: (evt) => {
        var mainScreenSetForm = $('.gigya-screen-content .gigya-newsletter-form'),
            emailField        = mainScreenSetForm.find('[name="profile.email"]'),
            nameField         = mainScreenSetForm.find('[name="profile.firstName"]'),
            lastNameField     = mainScreenSetForm.find('[name="profile.lastName"]'),
            genderField       = mainScreenSetForm.find('[name="profile.gender"]');

        emailField.prop('disabled', true);
        nameField.prop('disabled', true);
        lastNameField.prop('disabled', true);
        genderField.prop('disabled', true);

        gigyaLiteRegistration.wrapFooterNewsletterFields(mainScreenSetForm);
        gigyaLiteRegistration.prefillLanguage(mainScreenSetForm);
        gigyaLiteRegistration.extractAndPrefillUserEmail(mainScreenSetForm);

        personalizeService.getPersonalizedData().then(function (data) {
            // Check if there is session on gigya and hybris
            // Gigya does not support multiple sessions but hybris is supporting, so we need to be aware here and handle that case
            if (data.loginState === '0' || !isGigyaUserAuthenticated) {
                gigyaLiteRegistration.extractAndPrefillUserEmail(mainScreenSetForm);
                emailField.prop('disabled', false);
                nameField.prop('disabled', false);
                lastNameField.prop('disabled', false);
                genderField.prop('disabled', false);
            }
        });

        if (evt.detail.currentScreen === CDC_SUBSCRIBE_IN_STORE_WITH_EMAIL_SCREEN) {
            // Call newsletter handler for checking user email
            const liteNewsletterInStoreScreensetForm = $('#cdc-gigya-subscribe-in-store-with-email-container');
            const storeIDField                       = liteNewsletterInStoreScreensetForm.find('[name="data.storeId"]');
            const storeId                            = $('.js-physical-store').data('store-id');

            if (storeId !== undefined) {
                window.localStorage.setItem('storeId', storeId);
                storeIDField.val(storeId);
            }

            // Existing newsletter registration check
            const $registerForm = liteNewsletterInStoreScreensetForm.find('.gigya-subscribe-with-email-form');
            const $emailInput   = $registerForm.find('input[name="profile.email"]');
            const $submitButton = $registerForm.find('.gigya-input-submit');
            gigyaLiteRegistration.newsletterCheck($registerForm, $emailInput, $submitButton);
        }

        if (evt.detail.currentScreen === CDC_SUBSCRIBE_WITH_EMAIL_SCREEN) {
            // Existing newsletter registration check
            const $registerForm  = $('#cdc-gigya-subscribe-with-email-container .gigya-subscribe-with-email-form');
            const $emailInput    = $registerForm.find('input[name="profile.email"]');
            const $submitButton  = $registerForm.find('.gigya-input-submit');
            const $termsCheckbox = $registerForm.find('.gigya-terms-checkbox');

            if (!window.isGigyaUserAuthenticated) {
                // Form is prefilled, no need to disable button at this moment
                $submitButton.attr('disabled', true);
            }

            gigyaLiteRegistration.newsletterCheck($registerForm, $emailInput, $submitButton, $termsCheckbox);
        }

        if (evt.detail.currentScreen.startsWith(gigyaLiteRegistration.CDC_CONTEST_PARTICIPATION_PREFIX) ? evt.detail.currentScreen : false) {

            // Call caching methods if component exsists
            if ($('.contest-page__questions').length) {
                contestParticipation.init();
            }

            const $contestForm         = $('#cdc-gigya-contest-container .gigya-subscribe-with-email-form');
            const emailContestField    = $contestForm.find('[name="profile.email"]'),
                  nameContestField     = $contestForm.find('[name="profile.firstName"]'),
                  lastNameContestField = $contestForm.find('[name="profile.lastName"]'),
                  genderContestField   = $contestForm.find('[name="profile.gender"]'),
                  $newsletterCheckbox  = $contestForm.find('.nl-checkbox input');

            emailContestField.prop('disabled', true);
            nameContestField.prop('disabled', true);
            lastNameContestField.prop('disabled', true);
            genderContestField.prop('disabled', true);

            gigyaLiteRegistration.prefillLanguage($contestForm);

            personalizeService.getPersonalizedData().then((data) => {
                if (data.loginState === '0') {
                    emailContestField.prop('disabled', false);
                    nameContestField.prop('disabled', false);
                    lastNameContestField.prop('disabled', false);
                    genderContestField.prop('disabled', false);
                }
            });

            $contestForm.find('.wrap-element').wrapAll('<div class="registration-nl__additional d-none">');
            $contestForm.find('.wrap-element-date').wrapAll('<div class="registration-nl__date-fields">');
            $contestForm.find('.wrap-element-date:not(:last-child)').after('<span class="date-delimiter"></span>');

            $newsletterCheckbox.on('change', function () {
                if (this.checked) {
                    $contestForm.find('.registration-nl__additional').removeClass('d-none');
                } else {
                    $contestForm.find('.registration-nl__additional').addClass('d-none');
                }
            });

            $newsletterCheckbox.trigger('change');
        }
    },

    liteRegisterAfterSubmit: (evt) => {
        if ('detail' in evt) {
            var data              = evt.detail,
                cdcResponseStatus = data.response.status;
            // an error on form validation occurred
            if (cdcResponseStatus === 'FAIL') {
                // do nothing, form should show error message
                return false;
            } else if (cdcResponseStatus === 'OK') {
                if (data.screen === CDC_SUBSCRIBE_WITH_EMAIL_SCREEN) {
                    document.cookie = `${gigyaLiteRegistration.newsletterCookieName}=true;path=/`
                }
                if (data.screen === CDC_SUBSCRIBE_IN_STORE_WITH_EMAIL_SCREEN) {
                    window.location.href = alphatauri.config.encodedContextPath + '/newsletter/subscribe-in-store/confirmation';
                }
                if (data.screen.includes(gigyaLiteRegistration.CDC_CONTEST_PARTICIPATION_PREFIX)) {
                    const nlSubscription = data.subscriptions.newsletter.email.isSubscribed || false;
                    window.location.href = alphatauri.config.encodedContextPath + `/contest-success?nl=${nlSubscription}`;
                }
            } else {
                console.warn('Error: unexpected status returned from CDC server, response is' + cdcResponseStatus);
            }
        }
    },

    liteRegistrationSubmit: (event) => {
        gigya.clearUncheckedSubscriptions(event);
        if (event.detail.screen !== CDC_SUBSCRIBE_IN_STORE_WITH_EMAIL_SCREEN) {
            gigya.setAdditionalGeoDetails(event);
        }
        gigya.clearEmailForLoggedIn(event);
        gigya.setSpecialNlTag(event);
        contestParticipation.injectContestSubscriptionTagData(event);
    },

    newsletterConfirmationInStoreBack: (event) => {
        const nlInStoreConfirmation = $('.page-newsletterSubcribeInStoreConfirmationPage');
        const backToFormBtn         = nlInStoreConfirmation.find('.newsletter__back-button');
        const previousStoreId       = window.localStorage.getItem('storeId');
        const nlStoreUrl            = window.location.origin + alphatauri.config.encodedContextPath + '/newsletter/subscribe-in-store/?storeid=';

        if (nlInStoreConfirmation.length) {
            if (previousStoreId !== undefined) {
                backToFormBtn.attr('href', nlStoreUrl + previousStoreId);
            }
        }
    },

    contestSuccessPageHandle() {
        const successContestComponent = $('.contest-page__success-component');
        const nlTitle                 = successContestComponent.find('.page-contest__success-title--newsletter');
        const nlText                  = successContestComponent.find('.page-contest__success-title--newsletter-text');
        const urlParam                = new URLSearchParams(window.location.search).get('nl');

        successContestComponent.removeClass('invisible');

        if (successContestComponent.length && urlParam === 'true') {
            nlTitle.removeClass('d-none');
            nlText.removeClass('d-none');
        }
    },

    fetchSubscriptionData(email) {
        return $.ajax({
            url:         `${ACC.config.encodedContextPath}/gigyaraas/isSubscribed?email=${email}`,
            method:      'POST',
            dataType:    'json',
            contentType: 'application/json'
        });
    },

    alreadySubscribedActions(response, email) {
        tooltip.showFormError(response.message);
        if (response.subscriptionState === gigyaLiteRegistration.pendingSubscription) {
            // If user is subscribed but still in pending state
            gigyaLiteRegistration.triggerDoiResend(email);
        }
    },

    newsletterCheck($registerForm, $emailInput, $submitButton, $termsCheckbox = undefined) {
        /**
         * IMPLEMENTATION ON CDC SIDE
         * Screen-set: ATA-LiteRegistration
         * JS METHOD: onBeforeSubmit
         * Contact point: window.allowSubmitSubscribeInStore
         * Description: We are preventing form submit using allowSubmitSubscribeInStore flag
         */

        let checkDone                      = false;
        window.allowSubmitSubscribeInStore = false;

        if ($registerForm.length) {

            $emailInput.on('blur', function () {
                checkDone = false;
                if ($termsCheckbox?.length && $termsCheckbox.find('input.gigya-input-checkbox').is(':checked')) {
                    $submitButton.removeAttr('disabled');
                }
                if (!$termsCheckbox?.length) {
                    $submitButton.removeAttr('disabled');
                }
            });

            if ($termsCheckbox?.length) {
                $termsCheckbox.find('.gigya-input-checkbox').on('change', function () {
                    if (!$(this).is(':checked') || !$emailInput.val().length) {
                        $submitButton.attr('disabled', true);
                    } else {
                        $submitButton.removeAttr('disabled');
                    }
                });
            }

            // Bind submit event and prevent it until email is checked
            $registerForm.on('submit', function () {
                if (!$emailInput.hasClass('.gigya-error')) {
                    if (!checkDone) {
                        const request = gigyaLiteRegistration.fetchSubscriptionData($emailInput.val());

                        request.done((response) => {
                            checkDone = true;

                            if (!response.allowSubscription) {
                                // If user is subscribed
                                gigyaLiteRegistration.alreadySubscribedActions(response, $emailInput.val())
                                $submitButton.attr('disabled', 'disabled');
                            } else {
                                window.allowSubmitSubscribeInStore = true;
                                $submitButton.trigger('click');
                            }

                            if ($termsCheckbox.find('input.gigya-input-checkbox').is(':checked')) { // safety check if HTML manipulated
                                // Wrapper id is needed to load next screens
                                const wrapperId     = $('.js-newsletter-wrapper').attr('id');
                                const userFirstName = $registerForm.find('input[name="profile.firstName"]').val();
                                const userEmail     = $registerForm.find('input[name="profile.email"]').val();

                                if (wrapperId && userFirstName && userEmail) {
                                    response.hasFullAccount
                                            ? gigyaLiteRegistration.loadThankYouSection(wrapperId, userFirstName)
                                            : gigyaLiteRegistration.loadLiteProgressionSection(wrapperId, userEmail, userFirstName);
                                }
                            }
                        });
                    }
                }
            });
        }
    },

    triggerDoiResend(email) {
        const requestDoi = $.ajax({
            url:    `${ACC.config.encodedContextPath}/gigyaraas/resendDOIConfirmationEmail?email=${email}&subscriptionId=newsletter`,
            method: 'POST',
        });

        requestDoi.done(() => {
            logger.log('TRIGGERED : /resendDOIConfirmationEmail');
        });
    },

    loadThankYouSection(wrapperId, userFirstName = '') {
        const thankYouSection = $.ajax({
            url:         `${ACC.config.encodedContextPath}/newsletter/thank-you-section`,
            method:      'POST',
            contentType: 'application/json',
            dataType:    'html',
            data:        JSON.stringify({
                'wrapperId': wrapperId,
                'firstName': userFirstName
            })
        });

        thankYouSection.done((response) => {
            logger.log('TRIGGERED : thankYouSection load');

            const thankYouSection = $(response);

            $('#newsletter-register-popup').html(thankYouSection)
        }).fail((jqXHR) => {
            logger.error(`${jqXHR.status} error in requesting thank you section`)
        });
    },

    handleLiteProgressionScreen: (email, userFirstName) => {
        const $password          = $('#newsletter-register__lite-progression-password');
        const $checkbox          = $('#newsletter-register__lite-progression-terms');
        const $passwordError     = $('#newsletter-register__password--error');
        const $progressionForm   = $('#newsletter-register__lite-progression-form');
        const $progressionButton = $('#newsletter-register__start-progression');

        let readyToProgress = false;

        function checkValidity() {
            if ($checkbox.is(':checked') && $password.val().length >= 8) {
                readyToProgress = true;
                $progressionButton.removeAttr('disabled');
            } else {
                readyToProgress = false;
                $progressionButton.attr('disabled', true);
            }
        }

        $checkbox.on('change', () => {
            if (!$checkbox.is(':checked')) {
                $checkbox.siblings('label').addClass('invalid');
            } else {
                $checkbox.siblings('label').removeClass('invalid');
            }
            checkValidity();
        });

        $password.on('keyup', () => {
            $password.length && $password.val().length < 8
                    ? $passwordError.removeClass('d-none')
                    : $passwordError.addClass('d-none');
            checkValidity();
        });

        $progressionForm.on('submit', (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (readyToProgress) {
                gigyaLiteRegistration.processLiteProgression($password.val(), email, userFirstName);
            }
        });
    },

    loadLiteProgressionSection(wrapperId, email = '', userFirstName = '') {

        const liteProgressionSection = $.ajax({
            url:         `${ACC.config.encodedContextPath}/newsletter/lite-progression-section`,
            method:      'POST',
            contentType: 'text/plain',
            dataType:    'text',
            data:        wrapperId
        });

        liteProgressionSection.done((response) => {
            const liteProgressionSection = $(response);
            $('#newsletter-register-popup').html(liteProgressionSection);
            gigyaLiteRegistration.handleLiteProgressionScreen(email, userFirstName);
        }).fail((jqXHR) => {
            logger.error(`${jqXHR.status} error in requesting lite progression section`)
        });
    },

    processLiteProgression(password, email = '', userFirstName = '') {
        const liteProgression = $.ajax({
            url:         `${ACC.config.encodedContextPath}/newsletter/lite-progression`,
            method:      'POST',
            contentType: 'application/json',
            dataType:    'text',
            data:        JSON.stringify({
                'password': password,
                'email':    email
            })
        });

        liteProgression.done((response) => {
            logger.log('TRIGGERED : liteProgression process');

            if (response) {
                const wrapperId = $('.js-newsletter-wrapper').attr('id');
                gigyaLiteRegistration.loadThankYouSection(wrapperId, userFirstName);
            } else {
                tooltip.showFormError('Error during registration');
            }

        }).fail((jqXHR, textStatus, errorThrown) => {
            logger.error(`${jqXHR.status} error in processing lite progression request`)
            tooltip.showFormError('Error during registration');
        });
    },

    bindHandler: () => {
        document.addEventListener('gigya-lite-registration-after-screenload', gigyaLiteRegistration.liteRegisterAfterLoad);
        document.addEventListener('gigya-lite-registration-after-submit', gigyaLiteRegistration.liteRegisterAfterSubmit);
        document.addEventListener('gigya-lite-registration-submit', gigyaLiteRegistration.liteRegistrationSubmit);

        // In store success page button URL setter
        gigyaLiteRegistration.newsletterConfirmationInStoreBack();
        gigyaLiteRegistration.contestSuccessPageHandle();
    }
}

export default gigyaLiteRegistration;
